import { useParams } from "react-router-dom";

import { useGetCustomLongfield01 } from "api/queries/quotation/useGetCustomLongfield01";
import CustomLongfield from "pages/common/ShipmentQuotesV2/components/CustomLongfield";

const customLongfieldDataSelector = (res: any) => res.data;

type ShipperCustomLongfieldProps = {
  customLongfield: string;
};

function ShipperCustomLongfield(props: ShipperCustomLongfieldProps) {
  const { customLongfield } = props;
  const { id } = useParams();

  const { data } = useGetCustomLongfield01({
    shipmentId: id!,
    options: { select: customLongfieldDataSelector },
  });

  return data && data.is_custom_longfield1_enabled && <CustomLongfield customLongfield={customLongfield} />;
}

export default ShipperCustomLongfield;
